import {
  ArrowUpOnSquareIcon,
  GlobeAltIcon,
  SparklesIcon,
  UserPlusIcon,
} from "@heroicons/react/24/outline";

import { CheckCircleIcon } from "@heroicons/react/20/solid";

import clsx from "clsx";

export default function OnboardingProgressBar({ currentStep = 1 }) {
  const steps = [
    {
      name: "Enter website",
      description: "Your website URL",
      icon: GlobeAltIcon,
    },
    {
      name: "Upload content",
      description: "To train your AI agent",
      icon: ArrowUpOnSquareIcon,
    },
    {
      name: "Test your AI agent",
      description: "Ask your AI agent questions",
      icon: UserPlusIcon,
    },
    {
      name: "Deploy",
      description: "Launch on your website",
      icon: SparklesIcon,
    },
  ];

  return (
    <nav aria-label="Progress">
      <ol className="flex items-center">
        {steps.map((step, idx) => {
          const stepNumber = idx + 1;
          const isCompleted = currentStep > stepNumber;
          const isCurrent = currentStep === stepNumber;
          const isUpcoming = stepNumber > currentStep;

          return (
            <li
              key={step.name}
              className={clsx("relative", {
                "pr-48": idx !== steps.length - 1,
              })}
            >
              <div>
                <div
                  aria-hidden="true"
                  className="absolute inset-0 flex items-center"
                >
                  <div
                    className={clsx("h-0.5 w-full", {
                      "bg-gray-300": isUpcoming || isCurrent,
                      "bg-green-600": isCompleted,
                    })}
                  />
                </div>

                <div className="relative flex items-center justify-center bg-white p-2 border rounded-md border-gray-200">
                  {isCompleted ? (
                    <CheckCircleIcon
                      aria-hidden="true"
                      className="size-5 text-green-600"
                    />
                  ) : (
                    <step.icon
                      aria-hidden="true"
                      className="size-5 text-gray-500"
                    />
                  )}

                  <div className="absolute top-16 left-0 right-0 text-nowrap flex flex-col gap-1 text-center items-center justify-center">
                    <span
                      className={clsx("font-semibold", {
                        "text-gray-900": isCurrent || isCompleted,
                        "text-gray-400": isUpcoming,
                      })}
                    >
                      {step.name}
                    </span>
                    <span
                      className={clsx({
                        "text-gray-800": isCompleted || isCurrent,
                        "text-gray-400": isUpcoming,
                      })}
                    >
                      {step.description}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
